import serviceCategoriesApi from "@/api/serviceCategories";
const state = {};
const actions = {
    getAll(context) {
        return serviceCategoriesApi.getAll();
    },
    get(context, payload) {
        return serviceCategoriesApi.get(payload.id);
    },
    create(context, payload) {
        return serviceCategoriesApi.create(payload.serviceCategory);
    },
    edit(context, payload) {
        return serviceCategoriesApi.edit(payload.id, payload.serviceCategory);
    }
};
const getters = {};
const mutations = {};
export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
